/**
 * Fetch with retries on network failure / 502 / 503.
 * @param {string} input
 * @param {RequestInit} [init]
 * @param {{ retries?: number, retryDelayMs?: number }} [opts]
 */
export async function fetchWithRetry(input, init = {}, opts = {}) {
  const retries = opts.retries ?? 2;
  const retryDelayMs = opts.retryDelayMs ?? 800;
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await fetch(input, init);
      if (res.status === 502 || res.status === 503) {
        if (attempt === retries) return res;
        await new Promise((r) => setTimeout(r, retryDelayMs * (attempt + 1)));
        continue;
      }
      return res;
    } catch (e) {
      lastErr = e;
      if (attempt === retries) throw e;
      await new Promise((r) => setTimeout(r, retryDelayMs * (attempt + 1)));
    }
  }
  throw lastErr;
}
